export default {"src":"/_next/static/media/formationBanner2.1811e26d.svg","height":71,"width":60,"blurWidth":0,"blurHeight":0};